import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { db } from '../../Firebase/Firebase';
import Navbar from '../../Components/NavBarAirbnbStyle';
import Footer from '../../Components/footer';
import './Membresias.css';
import ModalMembresia from '../../Components/ModalMembresia';
import { collection, getDocs, addDoc, updateDoc, doc, setDoc } from 'firebase/firestore';

const MembresiasView = () => {
    const { idMarca, idLugar } = useParams(); // lugar puede venir o no
    const navigate = useNavigate();
    const [membresias, setMembresias] = useState([]);
    const [loading, setLoading] = useState(true);
    const [mostrarModal, setMostrarModal] = useState(false);
    const [membresiaActual, setMembresiaActual] = useState(null); // null = crear nueva
    const handleGuardarMembresia = async (data) => {
        try {
            if (membresiaActual) {
                // Si estás editando, ya tienes el ID
                const id = membresiaActual.id;
                const refLugar = doc(db, 'marca', idMarca, 'lugar', idLugar, 'membresias', id);
                const refGlobal = doc(db, 'membresias', id);

                await updateDoc(refLugar, data);
                await updateDoc(refGlobal, data);

                alert('✅ Membresía actualizada');
            } else {
                // Si estás creando una nueva, generamos el ID y usamos setDoc
                const nuevoId = doc(collection(db, 'membresias')).id; // genera un ID sin guardar aún

                const refLugar = doc(db, 'marca', idMarca, 'lugar', idLugar, 'membresias', nuevoId);
                const refGlobal = doc(db, 'membresias', nuevoId);

                const dataFinal = {
                    ...data,
                    id: nuevoId,
                    fechaCreacion: new Date()
                };

                await setDoc(refLugar, dataFinal);
                await setDoc(refGlobal, dataFinal);

                alert('✅ Membresía creada');
            }

            setMembresiaActual(null);
            setMostrarModal(false);
            fetchMembresias(); // o recargar el estado manualmente

        } catch (err) {
            console.error('Error al guardar membresía', err);
            alert('❌ Error al guardar');
        }
    };

   const fetchMembresias = async () => {
    try {
        const membresiasRef = collection(db, 'marca', idMarca, 'lugar', idLugar, 'membresias');
        const snapshot = await getDocs(membresiasRef);
        const lista = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setMembresias(lista);
        setLoading(false);
    } catch (error) {
        console.error('Error al obtener membresías:', error);
        setLoading(false);
    }
};
useEffect(() => {
    fetchMembresias();
}, [idMarca, idLugar]);



    return (
        <>
            <Navbar />
            <div className="membresias-container">
                <div className="membresias-header">
                    <h2>Membresías</h2>
                    <button
                        className="btn-nueva-membresia"
                        onClick={() => {
                            setMembresiaActual(null); // crea nueva
                            setMostrarModal(true);
                        }}
                    >
                        ➕ Nueva Membresía
                    </button>

                </div>

                {loading ? (
                    <p>Cargando...</p>
                ) : membresias.length === 0 ? (
                    <div className="mensaje-vacio">
                        <h3>🚀 ¡Aún no tienes membresías creadas!</h3>
                        <p>Empieza ahora creando tu primera membresía para ofrecer más valor a tus clientes.</p>
                        <button className="btn-nueva-membresia" onClick={() => {
                            setMembresiaActual(null); // crea nueva
                            setMostrarModal(true);
                        }}>
                            Crear mi primera membresía
                        </button>
                    </div>
                ) : (
                    <div className="membresias-lista">
                        {membresias.map((membresia) => (
                            <div className="membresia-card" key={membresia.id}>
                                <h4>{membresia.nombre}</h4>
                                <p>{membresia.descripcion}</p>
                                <p><strong>Precio:</strong> ${membresia.precio}</p>
                                <button
                                    onClick={() => {
                                        setMembresiaActual(membresia);
                                        setMostrarModal(true);
                                    }}
                                    className="btn-editar-membresia"
                                >
                                    ✏️ Editar
                                </button>

                            </div>
                        ))}
                    </div>
                )}
            </div>
            <Footer />
            <ModalMembresia
                isOpen={mostrarModal}
                onClose={() => {
                    setMostrarModal(false);
                    setMembresiaActual(null);
                }}
                onGuardar={handleGuardarMembresia}
                membresiaInicial={membresiaActual}
            />

        </>
    );
};

export default MembresiasView;
